










import Vue from 'vue'
import Navbar from '@/views/Navbar.vue'

export default Vue.extend({
  components: { Navbar },
  created () {
    this.$store.dispatch('getCivilizationData')
  }
})
